/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespSortItems_itemSearch = {
    readonly sort: {
        readonly options: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly displayName: string | null;
        } | null> | null;
        readonly currentOption: {
            readonly urlLabel: string | null;
        } | null;
    } | null;
    readonly " $refType": "SbRespSortItems_itemSearch";
};
export type SbRespSortItems_itemSearch$data = SbRespSortItems_itemSearch;
export type SbRespSortItems_itemSearch$key = {
    readonly " $data"?: SbRespSortItems_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespSortItems_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "urlLabel",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SbRespSortItems_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sort",
      "storageKey": null,
      "args": null,
      "concreteType": "SortType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "options",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseSortAvailableOptions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "linkReference",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "displayName",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentOption",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseSortCurrentOption",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '67d09e7a3205650df601a6107e2c7b22';
export default node;
